export const dataExperiences = [
      {
            id: 1,
            title: "Développeur Web - Full Stack",
            date: "05/03/2021-30/10/2021",
            location: "Senonches",
            text: `Projet web E-commerce Symfony 5.`,
            missions: [
                  {
                        id: 1,
                        title: "Partie Front/design/correction des bugs",
                  },
                  {
                        id: 2,
                        title: "Data-Binding/Gestion du Store",
                  },
                  {
                        id: 3,
                        title: "La familiarisation avec les différents outils de l'app.",
                  },
                  {
                        id: 4,
                        title: "(Front/Back)",
                  },
                  {
                        id: 5,
                        title: "Gestion de la BDD (MySQL)",
                  },
                  {
                        id: 5,
                        title: "Paiemenent stripe, Paypal, Mailjet",
                  },
                  {
                        id: 5,
                        title: "Mise en production avec Heroku",
                  },
            ],
      },
      {
            id: 2,
            title: "Dessinateur industriel",
            date: "01/08/2014 - Actuel",
            location: "Fontaine la guyon",
            text: `Deviseur chiffreur, je réalise les chiffrages pour un portefeuille de 1.5 ML à  2 ML€ .
            Je réalise des dessins de pièces 3D sous SolidWorks et la mise en plan 2D de fabrication et d’assemblage.
            Je conçois, développe et réalise la mise en fabrication des pièces mécaniques, tôlerie, tuyauterie et plasturgie,
                        suivant un cahier des charges en respectant les normes ISO en vigueur. Ainsi que les nomenclatures de fabrication.`,
            missions: [
                  {
                        id: 1,
                        title: "Deviseur chiffreur",
                  },
                  {
                        id: 2,
                        title: "Technicien bureau d’études",
                  },
                  {
                        id: 3,
                        title: "Méthodes",
                  },
            ],
      },
]
export default dataExperiences